import React, { useState } from 'react'
import ConfigurationsFilters from './ConfigurationsFilters'
import ConfigurationsTable from './ConfigurationsTable'
import { Spacing } from '../../../components/table/Table'
import TableViewType from '../../../components/tableViewType/TableViewType'
import { ILink } from '../../../types'
import { PATHS } from '../../../routes/Routes'
import PageHeader from '../../../components/pageHeader/PageHeader'
import ConfigurationActions from './Actions/ConfigurationActions'

const Configurations = () => {
  const [viewType, setViewType] = useState<Spacing>(Spacing.Default)
  const navLinks: ILink[] = [
    {
      label: 'Batch Activity',
      link: PATHS.BATCH_ACTIVITY,
    },
    {
      label: 'Configurations',
      link: PATHS.VIEW_CONFIGURATIONS,
    },
  ]
  return (
    <div className='page-container'>
      <div className='page-content'>
        <PageHeader header='Configurations' navLinks={navLinks}>
          <ConfigurationActions />
        </PageHeader>
        <div className='table-filters'>
          <div className='filters-container'>
            <ConfigurationsFilters />
          </div>
          <div className='table-view-type'>
            <TableViewType viewType={viewType} setViewType={setViewType} />
          </div>
        </div>
        <ConfigurationsTable spacing={viewType} />
      </div>
    </div>
  )
}
export default Configurations
